import React from "react";

import LearnerClassroomTabbedLayout from "../../layout/LearnerClassroomTabbedLayout";
import LearnerClassroomV2Layout from "../../layout/LearnerClassroomV2Layout";
import {
  LearnerClassroomProvider,
  useLearnerClassroomContext,
} from "../../providers/LearnerClassroomProvider";

/** Picks V2 (no-tab) or V1 (tabbed) layout based on context. */
const LearnerClassroomLayoutSwitch = () => {
  const { activity, section } = useLearnerClassroomContext();
  const usesNewAsyncLayout = activity?.details?.asyncRenderVersion === 2;
  const isSelfPaced = section?.is_self_paced === true;

  if (usesNewAsyncLayout && isSelfPaced) {
    return <LearnerClassroomV2Layout />;
  }

  return <LearnerClassroomTabbedLayout />;
};

interface LearnerClassroomProps {
  sectionUid: string;
}

const LearnerClassroom = ({ sectionUid }: LearnerClassroomProps) => {
  return (
    <LearnerClassroomProvider sectionUid={sectionUid}>
      <LearnerClassroomLayoutSwitch />
    </LearnerClassroomProvider>
  );
};

export default React.memo(LearnerClassroom);
